'use strict';

// Import Error Console
import ErrorConsole from './error-console.js';
new ErrorConsole({elementId: 'error-console', alertOnError: false});

// External libraries
// Note: These are loaded globally
import HowlerJS from '../lib/howler.min.js';
// import HowlerSpatialJS from '../lib/howler.spatial.min.js';

// For earlier IE/IOS support
import '../../node_modules/babel-polyfill/dist/polyfill';

// Import Onyx
import * as Onyx from '../lib/onyx.min.js';
Onyx.CONST.DIRECTIONAL_SHADOWS_ENABLED = false;
Onyx.CONST.DEFAULT_SHADOW_BIAS = 0.004;

// Central Station
import CentralStationV2 from '../lib/centralstation.js';

// Import Scenes
import ScenePreloader from '../routes/preloader/index.js';
import SceneTitle from '../routes/title/index.js';
import SceneGame from '../routes/game/index.js';
import SceneGameover from '../routes/gameover/index.js';
import ScenePedagogic from '../routes/pedagogic/index.js';
import SceneLevelComplete from '../routes/level-complete/index.js';
import SceneCharacterSelect from '../routes/character-select/index.js';

// Init game
class Game {
    constructor(){
        this.name = "RadRobotRace";
        this.portalName = "RadRobotRace"; // ID used in Student Portal
        this.gameSession = null;
        this.music = [];
        this.sfx = [];
        
        this.router = new Onyx.Router({
            map: {
                "preloader": { module: new ScenePreloader() },
                "title": { module: new SceneTitle() },
                "character-select": { module: new SceneCharacterSelect() },
                "game": { module: new SceneGame() },
                "gameover": { module: new SceneGameover() },
                "pedagogic": { module: new ScenePedagogic() },
                "level-complete": { module: new SceneLevelComplete() } 
            }
        });

        window.addEventListener('DOMContentLoaded', () => {
            window.centralStation.studentPortalAuth();
            window.centralStation.questionSkill = "blending";

            window.centralStation.gameSession(window.game.name).then((data) => {
                window.game.gameSession = data.id;
                this.router.navigate("preloader"); 
            }).catch(() => { 
                // Keep going?
                // (window.top || window).location = this.centralStation.studentPortalUrl;
            });
        });
    }

    hideLoadingMask() {
        document.getElementById("loading-mask").classList.remove("cover");

        window.setTimeout(function(){
            document.getElementById("loading-mask").style.display = "none";
        }, 1000);
    }

    showLoadingMask() {
        document.getElementById("loading-mask").style.display = "initial";

        window.setTimeout(function(){
            document.getElementById("loading-mask").classList.add("cover");
        }, 100);
    }
}

window.game = new Game();
window.router = window.game.router;

window.centralStation = new CentralStationV2(environment);
window.centralStation.TTSSpeak("");